import React, { createContext, PropsWithChildren, useContext, useState } from "react";
import ReactModal from "react-modal";
import { Modal } from "./Modal";
import { mql } from "../../styles/breakpoints";
import styled from "@emotion/styled";
import { Success } from "./FormContent/Success";

export type ModalProps = Partial<ReactModal.Props> & {
  title?: string;
  subtitle?: string;
  policy?: boolean;
  onOk?: () => Promise<void>;
  onCancel?: () => void;
  content: React.FunctionComponent<{ onSuccess?(): void }>;
};


export interface FormModalContextData {
  show: (props: ModalProps) => void;
}

export function useFormModalContext() {
  const ctx = useContext(FormModalContext);
  if (!ctx) {
    throw new Error("Expected to be inside ModalContext");
  }

  return ctx;
}

export const FormModalContext = createContext<FormModalContextData | null>(null);

const Policy = styled.p`
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #A9A8B7;

  & a {
    color: #A9A8B7;
    text-decoration: underline;
  }

  ${ mql.md } {
    font-size: 14px;
    line-height: 21px;
  }
`;

export function FormModalProvider(props: PropsWithChildren<{}>) {
  const [ modalProps, setModalProps ] = useState<ModalProps | null>();
  const [ success, setSuccess ] = useState(false);

  const ctxData: FormModalContextData = {
    show: setModalProps,
  };

  async function complete(answer: boolean) {
    if (!modalProps) {
      return;
    }

    if (answer) {
      await modalProps.onOk?.();
    } else {
      modalProps.onCancel?.();
    }

    setModalProps(null);
  }

  async function onClose() {
    await complete(false);
    setSuccess(false);
  }

  return <FormModalContext.Provider value={ ctxData }>
    { props.children }
    <Modal
      isOpen={ modalProps != null }
      onRequestClose={ onClose }
      title={ success ? "" : modalProps?.title }
      subtitle={
        success ? "" : (
          modalProps?.subtitle ?? "Напишите нам и мы ответим в течение одного рабочего дня."
        )
      }
      content={
        success ? <Success/> : <>
          { modalProps?.content &&
            (success ? <Success/> : <modalProps.content onSuccess={ () => setSuccess(true) }/>)
          }

          <Policy>
            Нажимая кнопку «Отправить», я подтверждаю, что ознакомлен(а) и
            принимаю <a href={ "https://www.pre-ambula.ru/personal-data-agreement/" }>условия</a> и <a
            href={ "https://www.pre-ambula.ru/personal-data-politika/" }>политику </a>
            обработки персональных данных
          </Policy>
        </>
      }
    />
  </FormModalContext.Provider>;
}